import { type TFunction } from 'i18next';
import { Calendar, Clock, Timer } from 'lucide-react';
import { type Tag } from 'types/wellbeing';
import { formatUnifiedDateSimple, formatUnifiedTime } from 'utils/date';
import { getTagCategoryIcon, tagColorVar } from 'utils/wellbeing';

export type MetaItem = { icon: React.ComponentType<{ className?: string }>; text: string };

type GetContentCardMetaRowsParams = {
  durationLabel: string | null;
  isVideoTip: boolean;
  startTime?: string;
};

export const getContentCardMetaRows = ({
  durationLabel,
  isVideoTip,
  startTime,
}: GetContentCardMetaRowsParams): MetaItem[][] => {
  const metaRows: MetaItem[][] = [];

  if (isVideoTip) {
    if (startTime || durationLabel) {
      const row: MetaItem[] = [];
      if (startTime) row.push({ icon: Calendar, text: formatUnifiedDateSimple(startTime) });
      if (durationLabel) row.push({ icon: Timer, text: durationLabel });
      metaRows.push(row);
    }
  } else {
    if (startTime) {
      metaRows.push([
        { icon: Calendar, text: formatUnifiedDateSimple(startTime) },
        { icon: Clock, text: formatUnifiedTime(startTime) },
      ]);
    }
    if (durationLabel) {
      metaRows.push([{ icon: Timer, text: durationLabel }]);
    }
  }

  return metaRows;
};

export const tagCategoryBadge = (tag: Tag | undefined, t: TFunction): React.ReactElement | null => {
  if (!tag) return null;
  const Icon = getTagCategoryIcon(tag.id);
  const label = t(`WellBeingContent.Tags.${tag.id}`);
  return (
    <div
      className="flex items-center justify-end gap-2 text-xs font-medium leading-4"
      style={{ color: tagColorVar(tag.colorText) }}
    >
      <Icon className="size-4 shrink-0" strokeWidth={2} aria-hidden />
      <span>{label}</span>
    </div>
  );
};
